import { c as _c } from "react/compiler-runtime";
import { usePromosPlacementEngine } from "modules/promos/hooks/usePromosPlacementEngine";
import { Renderer } from "modules/promos/components/Slot/Renderer";
import type { PromoDataProps } from "modules/promos/types";
export interface SlotProps {
  name: string;
}
export const Slot = t0 => {
  "use memo";

  const $ = _c(7);
  const {
    name
  } = t0;
  const {
    promos
  } = usePromosPlacementEngine();
  let t1;
  if ($[0] !== name || $[1] !== promos) {
    let t2;
    if ($[3] !== name) {
      t2 = promo => promo.slotName === name;
      $[3] = name;
      $[4] = t2;
    } else {
      t2 = $[4];
    }
    const candidatePromos = promos.filter(t2);
    t1 = candidatePromos.map(_temp);
    $[0] = name;
    $[1] = promos;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const promoComponents = t1;
  let t2;
  if ($[5] !== promoComponents) {
    t2 = <>{promoComponents}</>;
    $[5] = promoComponents;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  return t2;
};
function _temp(promo_0) {
  return <Renderer key={promo_0.promoId} promo={promo_0} />;
}